import { render, staticRenderFns } from "./AudioSearchReview2.vue?vue&type=template&id=aa1275ba"
import script from "./AudioSearchReview2.vue?vue&type=script&lang=js"
export * from "./AudioSearchReview2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports